import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RestService } from '../../services/rest-service';
import { AppSettings } from '../../shared/app-settings';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CameraServerService } from '../camera-server.service';
import { ToastrService } from 'ngx-toastr';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { TableElement } from '../site-list/site-list.component';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { AppConstants } from 'src/app/shared/app-constants';


@Component({
  selector: 'app-masking-data',
  templateUrl: './masking.component.html',
  styleUrls: ['./masking.component.scss']
,
  standalone: false
})
export class MaskingComponent implements OnInit {

  resolutions = [
    { name: "720p/1080p/4k/8k", value: "169", id: "169" },
    { name: "360p", value: "43", id: "43" }
  ]
  lpr = "true"
  potentialId: string = ""
  vpnIp: string = ""
  siteName: string = ""
  siteData: any;
  closeResult: string;
  isUpdated: boolean = false;
  selResolution = "169";
  selResolutionName = "720p/1080p/4k/8k";
  displayedColumns: string[] = ['id', 'rtspUrl', 'camDisplayName', 'timezone', 'action'];
  dataSource = new MatTableDataSource<TableElement>([]);
  dataSourceArray: any;
  selection = new SelectionModel<TableElement>(true, []);
  totalRecords: number;
  pageSize: number = 25;
  pageNumber: number = 0;
  selectRow: any = [];
  selectAllRow: any = [];
  camServerData: any;
  getCamWidth: string;
  getCamHeight: string;
  selectedCam: any;
  isFilterWithAnotherOption: boolean = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  isAnalyticIdSeven: boolean;

  constructor(
    private router: Router,
    public spinner: SpinnerService,
    private activatedroute: ActivatedRoute,
    private modalService: NgbModal,
    public cameraService: CameraServerService,
    public sanitizer: DomSanitizer,
    private toastr: ToastrService,) {

    let initData = this.router.getCurrentNavigation().extras.state;
    if (initData != null) {
      if (initData.isUpdated != null) {
        this.siteData = initData.site;
        this.isUpdated = initData.isUpdated;
      }
      else {
        this.siteData = initData;
      }
      if (this.siteData["aspectRatio"] == null) {
        this.siteData["aspectRatio"] = "169";
      }
      if (this.siteData["resolutionName"] == null) {
        this.siteData["resolutionName"] = "720p/1080p/4k/8k";
      }
      this.potentialId = this.siteData.potentialId;
      this.selResolution = this.siteData["aspectRatio"];
      this.selResolutionName = this.siteData["resolutionName"];
    }
  }

  onOptionsSelected(event) {
    this.selResolution = event;
    sessionStorage.setItem('selectResolution', event)
    for (var res of this.resolutions) {
      if (res.id == this.selResolution) {
        this.selResolutionName = res.name;
        if(this.selResolutionName === "360p"){
          this.isAnalyticIdSeven = false;
        } else {
          this.isAnalyticIdSeven = true;
        }
        break;
      }
    }
  }

  ngOnInit(): void {
    this.getSiteDetails();
    this.potentialId = sessionStorage.getItem("potentialId");
    let selectedResolution = sessionStorage.getItem('selectResolution');
    if (selectedResolution) {
      this.selResolution = selectedResolution
      for (const res of this.resolutions) {
        if (res.id == selectedResolution) {
          this.selResolutionName = res.name;
          break;
        }
      }
    } else {
      this.selResolution = "169";
      this.selResolutionName = "720p/1080p/4k/8k"
    }

    // this.potentialId = "727595";
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.pageNumber = this.paginator.pageIndex;
    this.pageSize = this.paginator.pageSize;
    this.sort.active;
    this.dataSource.sort = this.sort;
    this.sort.direction;
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
  }

  selectedRow(event: any, row: any) {
    event.stopPropagation();
  }

  changePaging(event: any) {
    this.pageNumber = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getSiteDetails();
  }

  getSiteDetails() {
    const potential_Id = sessionStorage.getItem("potentialId");
    // const potential_Id = "727595";
    this.spinner.activate();
    this.cameraService.getSiteDetailsForMasking(potential_Id).subscribe((res: any) => {
      if (res && res.success) {
        this.spinner.deactivate();
        this.siteData = res.data?.site;
        // this.dataSource = new MatTableDataSource<any>(res.data?.site.cams);
        this.totalRecords = res.data?.site.cams?.length;
        this.isAnalyticIdSeven = res.data?.site.analyticId === "7";
        this.dataSource.sort = this.sort;
        const end = (this.pageNumber + 1) * this.pageSize;
        const start = this.pageNumber * this.pageSize;
        const partResponseData = res.data?.site.cams?.slice(start, end);
        this.dataSource = new MatTableDataSource<any>(partResponseData);
      } else {
        this.spinner.deactivate();
        this.toastr.error(res?.message || AppConstants.defaultErrorMessage);
      }
    }, err => {
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
      }
    });
  }

  getMaskingData(cam: any) {
    var reqParam = {}
    this.spinner.activate();
    this.cameraService.getMasking(cam, reqParam).subscribe((res: any) => {
      if (res) {
        this.spinner.deactivate();
        let maskData = res?.data?.masking_data;
        this.camServerData = res?.data?.cam_server_data;
        this.getCamHeight = res?.data?.image_height;
        this.getCamWidth = res?.data?.image_width;
        let points_From_Camera = res?.data?.points_from_camera;
        if (maskData != null && maskData != "") {
          cam.maskingData = JSON.parse(maskData);
        }
        else {
          cam.maskingData = [];
        }
        const camData: any = {
          cam: cam,
          site: this.siteData,
          camServer: this.camServerData,
          ImageHeight: this.getCamHeight,
          ImageWidth: this.getCamWidth,
          Points_From_Camera:points_From_Camera,
          AnalyticIdSeven : this.isAnalyticIdSeven,
          resolutions: this.selResolutionName
        }
         sessionStorage.setItem("camdetails", JSON.stringify(camData));
         sessionStorage.setItem('siteData',this.siteData)
        this.router.navigate([`camera-server/masking/mask-cams/${cam.camUniqueId}`])
        // this.router.navigateByUrl(`camera-server/masking/mask-cams/${cam.camUniqueId}`, {
        //   state: {
        //     cam: cam,
        //     site: this.siteData,
        //     camServer: this.camServerData,
        //     ImageHeight: this.getCamHeight,
        //     ImageWidth: this.getCamWidth
        //   }
        // });
      } else {
        this.spinner.deactivate();
        this.toastr.error(res?.message || AppConstants.defaultErrorMessage);
      }
    }, err => {
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
      }
    });
  }

  maskData(element: any) {
    if (this.selResolution == "43") {
      element["resolution"] = "480x360";
      element["resolution.height"] = "360";
      element["resolution.width"] = "480";
      element["aspectRatio"] = "43";
      this.siteData["aspectRatio"] = "43";
      this.siteData["resolutionName"] = "360p";
    } else {
      element["resolution"] = "1280x720";
      element["resolution.height"] = "720";
      element["resolution.width"] = "1280";
      element["aspectRatio"] = "169";
      this.siteData["aspectRatio"] = "169";
      this.siteData["resolutionName"] = "720p/1080p/4k/8k";
    }
    this.getMaskingData(element);
  }
  updateMaskData(element){
    this.spinner.activate();
    if(element){
      let camUniqueId = element?.camUniqueId;
      this.cameraService.updateMaskByUniqId(camUniqueId).subscribe((res:any)=>{
        if(res?.success){
          this.toastr.success(`${res?.data?.charAt(0).toUpperCase() + res?.data.slice(1)}` || 'Masking points updated successfully');
          this.spinner.deactivate();
        } else {
          this.toastr.warning(`${AppConstants.defaultErrorMessage}`);
          this.spinner.deactivate();
        }
      });
    };
  };

  handleOpenFilter() {
    this.isFilterWithAnotherOption = !this.isFilterWithAnotherOption
  }

  searchWith() {
    var reqParam = {
      potentialId: this.potentialId,
      siteName: this.siteName,
      vpnIp: this.vpnIp
    }
    this.spinner.activate();
    this.cameraService.searchSiteBy(reqParam).subscribe((res: any) => {
      if (res) {
        this.spinner.deactivate();
        if (res.data != null) {
          sessionStorage.setItem("potentialId", res.data && res.data.site.potentialId)
          this.getSiteDetails();
        }
      } else {
        this.spinner.deactivate();
        this.toastr.error(res?.message || AppConstants.defaultErrorMessage);
      }
    }, err => {
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
      }
    });
  }

  editIp(pmodal, cam) {
    var self = this;
    this.selectedCam = cam;
    this.modalService.open(pmodal, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      if (result == "update") {
        self.saveInDb(cam)
      }
    }, (reason) => {
      this.closeResult = `Dismissed`;
    });
  }

  editLPR(pModal, cam) {
    var self = this;
    this.selectedCam = cam;
    if (this.selectedCam.lprEnabled) {
      this.lpr = "true";
    } else {
      this.lpr = "false";
    }
    this.modalService.open(pModal, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      if (result == "update") {
        self.saveInDbByActionType(cam, "UPDATE_LPR_ENABLED");
      }

    }, (reason) => {
      this.closeResult = `Dismissed`;
    });
  }

  private saveInDb(cam): void {
    var self = this;
    var req = {}
    let site_req = { "potentialId": self.siteData.potentialId, "cams": [cam] }
    req["site"] = site_req;
    req["actionType"] = "UPDATE_PRIVATE_IP";
    self.spinner.activate();
    // this.restService.postRequest(AppSettings.UPDATE_SITE_DATA, req).subscribe((res: any) => {
    //   self.spinner.deactivate();
    //   if (res.data != null) {
    //     console.log("Private ip is updated..")
    //   }
    // });
  }

  private saveInDbByActionType(cam, actionType): void {
    var self = this;
    var req = {}
    let site_req = { "potentialId": self.siteData.potentialId, "cams": [cam] }
    req["site"] = site_req;
    req["actionType"] = actionType;
    self.spinner.activate();
    // self.restService.postRequest(AppSettings.UPDATE_SITE_DATA, req).subscribe((res: any) => {
    //   self.spinner.deactivate();
    //   if (res.data != null) {
    //     console.log(actionType + " is updated..")
    //   }
    // });
  }

  stats() {
    this.router.navigateByUrl('/site-data/stats', { state: this.siteData });
  }

  docker() {
    this.router.navigateByUrl('/site-data/docker', { state: this.siteData });
  }

  siteDetails() {
    this.router.navigateByUrl('/site-data/site-details', { state: this.siteData });
  }

  camDetails(cam) {
    this.router.navigateByUrl('/site-data/cam-details', { state: { site: this.siteData, camDetails: cam } });
  }

  /**manual sync */
  manualSync() {
    let setNewResolution = ''
    if (this.selResolution == '43') {
      setNewResolution = '480x360'
    } else {
      setNewResolution = '1280x720'
    }
    this.spinner.activate();
    this.cameraService.manualSyncMasking(this.potentialId, setNewResolution).subscribe((res: any) => {
      if (res && res?.success) {
        this.toastr.success('Manual Sync Completed !!');
        this.spinner.deactivate();
      } else {
        this.toastr.error('Unable to Sync !!');
        this.spinner.deactivate();
      }
    }, (error) => {
      if (error) {
        this.toastr.error('Error occurred while syncing');
        this.spinner.deactivate();
      }
    }, () => {
      this.spinner.deactivate();
    })
  }

}
